export enum AuditingStep {
  Start = 'start',
  Infered = 'infered',
  Annotate = 'annotate',
  Audited = 'audited'
}

export enum AuditingStepEnum {
  setAuditingStep = 'SET_AUDITING_STEP'
}

export type setAuditingStepAction = {
  type: AuditingStepEnum.setAuditingStep;
  payload: {
    step: AuditingStep;
  };
};
